import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useScrollSpy } from 'components/ScrollSpy';
import { useGetActiveTabFromIntersectingSection } from 'hooks/useGetActiveTabFromIntersectingSection';
import { useTopHeaderHeight } from 'hooks/useTopHeaderHeight';
import { AccommodationPageNavSections } from 'modules/accommodation/types';
import { getIsTopHeaderHidden, getSearchDesktopHeaderHeight } from 'modules/search/selectors';
import { toggle } from 'opticks';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { PageWidthContainer } from '@daedalus/atlas/helpers/PageWidthContainer';
import { useBodyScrollLockObserver } from '@daedalus/atlas/Overlay/useBodyScrollLock';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { Tab, Tabs } from '@daedalus/shared/src/search/Tabs';
import { HeaderCTA } from '../Offers/HeaderCTA';
export const ACCOMMODATION_FIXED_HEADER_HEIGHT = 70;
const _exp = /*#__PURE__*/() => ({
  topOffset
}) => `${topOffset}px`;
const _exp4 = /*#__PURE__*/() => ({
  scrollBarGap
}) => scrollBarGap;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h14zlabc",
  propsAsIs: false,
  vars: {
    "h14zlabc-0": [_exp()],
    "h14zlabc-1": [_exp4(), "px"]
  }
});
const Spacer = /*#__PURE__*/styled('div')({
  name: "Spacer",
  class: "s1gr8yl0",
  propsAsIs: false
});
const OfferCtaWrapper = /*#__PURE__*/styled('div')({
  name: "OfferCtaWrapper",
  class: "o1hbr41x",
  propsAsIs: false
});
const handleScrollTop = () => window.scrollTo({
  top: 0,
  behavior: 'smooth'
});
interface Props {
  hasReviews?: boolean;
  hasFacilities?: boolean;
  hasPolicies?: boolean;
  isVisible?: boolean;
  isCtaVisible?: boolean;
  isLoading?: boolean;
}
export const AccommodationFixedHeader: React.FC<Props> = ({
  hasReviews = true,
  hasFacilities = true,
  hasPolicies = true,
  isCtaVisible,
  isVisible,
  isLoading = false
}) => {
  const {
    isDesktopMd,
    isDesktopLg
  } = useDeviceLayout();
  const isSearchBoxSticky = toggle('8d14a737-rsp-v2-improvements', false, isDesktopMd || isDesktopLg);
  const searchDesktopHeaderHeight = useSelector(getSearchDesktopHeaderHeight);
  const topHeaderIsHidden = useSelector(getIsTopHeaderHidden);
  const {
    scrollBarGap
  } = useBodyScrollLockObserver();
  const topHeaderHeight = useTopHeaderHeight();
  const stickyHeaderOffset = isSearchBoxSticky ? topHeaderIsHidden ? searchDesktopHeaderHeight - topHeaderHeight : searchDesktopHeaderHeight : 0;
  const stickyHeaderHeight = ACCOMMODATION_FIXED_HEADER_HEIGHT + searchDesktopHeaderHeight;
  const {
    onNavigate
  } = useScrollSpy();
  const onChange = (tab: string) => {
    if (tab === AccommodationPageNavSections.Photos) {
      handleScrollTop();
    } else {
      onNavigate(tab);
    }
  };
  const {
    activeTab
  } = useGetActiveTabFromIntersectingSection({
    intersectWithSectionAt: isSearchBoxSticky ? stickyHeaderHeight : ACCOMMODATION_FIXED_HEADER_HEIGHT,
    shouldSkip: toggle('8d14a737-rsp-v2-improvements', true, !isVisible)
  });
  if (!isVisible) {
    return null;
  }
  return <HeaderWrapper className={cx(scrollBarGap > 0 && '__scrollBarGap')} scrollBarGap={scrollBarGap} topOffset={stickyHeaderOffset}>
      <PageWidthContainer paddingDesktopXsSize="s500">
        <Tabs value={activeTab} onChange={onChange}>
          <Tab value={AccommodationPageNavSections.Photos}>
            <FormattedMessageWrapper defaultMessage="Photos" id="photos" />
          </Tab>
          {hasFacilities && <Tab value={AccommodationPageNavSections.Amenities}>
              <FormattedMessageWrapper id="amenities" defaultMessage="Amenities" />
            </Tab>}
          <Tab value={AccommodationPageNavSections.Rooms}>
            <FormattedMessageWrapper id="rooms" defaultMessage="Rooms" />
          </Tab>
          {hasReviews && <Tab value={AccommodationPageNavSections.Reviews}>
              <FormattedMessageWrapper defaultMessage="Reviews" id="reviews" />
            </Tab>}
          <Tab value={AccommodationPageNavSections.HotelLocation}>
            <FormattedMessageWrapper id="location" defaultMessage="Location" />
          </Tab>
          {hasPolicies && <Tab value={AccommodationPageNavSections.Policies}>
              <FormattedMessageWrapper defaultMessage="Property policies" id="propertyPolicy" />
            </Tab>}
          <Spacer />
          <OfferCtaWrapper>
            <HeaderCTA isLoading={isLoading} isVisible={isCtaVisible} />
          </OfferCtaWrapper>
        </Tabs>
      </PageWidthContainer>
    </HeaderWrapper>;
};

require("./AccommodationFixedHeader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AccommodationFixedHeader.tsx");